function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0805 13.0064L10.0492 8.78769C9.83202 8.65738 9.5615 8.65396 9.34105 8.77874C9.12064 8.90352 8.98438 9.13729 8.98438 9.3906V17.8281C8.98438 18.0814 9.12064 18.3152 9.34105 18.44C9.56108 18.5645 9.83159 18.5616 10.0492 18.431L17.0805 14.2123C17.2923 14.0852 17.4219 13.8563 17.4219 13.6093C17.4219 13.3624 17.2923 13.1335 17.0805 13.0064ZM10.3906 16.5862V10.6325L15.3521 13.6093L10.3906 16.5862Z",
  fill: "#F15B07"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7969 0.25H1.20312C0.814812 0.25 0.5 0.564812 0.5 0.953125V22.0469C0.5 22.4352 0.814812 22.75 1.20312 22.75H23.7969C24.1852 22.75 24.5 22.4352 24.5 22.0469C24.5 21.4914 24.5 1.16266 24.5 0.953125C24.5 0.568609 24.1851 0.25 23.7969 0.25ZM14.6094 4.46875L18.3594 1.65625H21.6734L17.8922 4.46875H14.6094ZM8.98438 4.46875L12.7344 1.65625H16.0156L12.2656 4.46875H8.98438ZM3.32656 4.46875L7.10783 1.65625H10.3906L6.64062 4.46875H3.32656ZM23.0938 2.35244V4.46875H20.2484L23.0938 2.35244ZM4.75156 1.65625L1.90625 3.77256V1.65625H4.75156ZM23.0938 21.3438H1.90625V5.875H23.0938V21.3438Z",
  fill: "#F15B07"
});

var SvgAddVideoOrange = function SvgAddVideoOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddVideoOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-video-orange.6a7ba92e.svg";
export { ForwardRef as ReactComponent };